import { render, staticRenderFns } from "./LogInView.vue?vue&type=template&id=641beccc&scoped=true"
import script from "./LogInView.vue?vue&type=script&lang=ts"
export * from "./LogInView.vue?vue&type=script&lang=ts"
import style0 from "./LogInView.vue?vue&type=style&index=0&id=641beccc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641beccc",
  null
  
)

export default component.exports